function chartData (type, reportData, definition, key, currency) {
  const labelKeys = definition.chartLabelKeys
  const labels = reportData.map(e => labelKeys.map(key => e[key]).join(' - '))
  const format = definition.table.find(e => e.key === type).format

  switch (definition.chart) {
    case 'PIE':
      return { labels, values: reportData.map(e => e[type]), format, isBestseller: key === 'best_seller' ? 20 : undefined, currency }

    case 'BAR_AND_LINE':
      let values = definition.chartValuePrefix
        .map(prefix => {
          return reportData.map(e => e[prefix + type])
        })
      let valueLabels = definition.chartValueLabel
      let types = definition.chartValuePrefix.map(() => 'bar')

      const showAverage = definition.table.find(e => e.key === type).chartAverage
      if (showAverage) {
        values = [reportData.map(e => e['ema'])].concat(values)
        valueLabels = ['10 days average'].concat(valueLabels)
        types = ['line'].concat(types)
      }

      return { labels, values, valueLabels, types, showAverage, format, currency }
  }
}

export default chartData



// WEBPACK FOOTER //
// ./src/libs/chartData.helper.js